import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Mail, Phone } from 'lucide-react';
import { contactMock } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-slate-50 border-t border-slate-200 text-slate-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-slate-900">AI pro pedagogy</span>
            </Link>
            <p className="text-slate-500 max-w-md leading-relaxed">
              Pomáháme pedagogům využívat umělou inteligenci jako praktickou pomůcku
              v každodenní práci. Méně administrativy, více času na děti.
            </p>
          </div>

          {/* Informace */}
          <div>
            <h4 className="text-slate-900 font-semibold mb-4">Informace</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/pro-reditele" className="hover:text-teal-600 transition-colors">
                  Pro ředitele
                </Link>
              </li>
              <li>
                <Link to="/pro-ucastniky" className="hover:text-teal-600 transition-colors">
                  Pro účastníky
                </Link>
              </li>
              <li>
                <Link to="/typy-skoleni" className="hover:text-teal-600 transition-colors">
                  Typy školení
                </Link>
              </li>
              <li>
                <Link to="/typy-skol" className="hover:text-teal-600 transition-colors">
                  Typy škol
                </Link>
              </li>
              <li>
                <Link to="/obsah-a-cena" className="hover:text-teal-600 transition-colors">
                  Obsah a cena
                </Link>
              </li>
              <li>
                <Link to="/reference" className="hover:text-teal-600 transition-colors">
                  Reference
                </Link>
              </li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="text-slate-900 font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${contactMock.email}`}
                  className="flex items-center gap-2 hover:text-teal-600 transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  {contactMock.email}
                </a>
              </li>
              {contactMock.phones.map((phone, index) => (
                <li key={index}>
                  <a
                    href={`tel:${phone.replace(/\s/g, '')}`}
                    className="flex items-center gap-2 hover:text-teal-600 transition-colors"
                  >
                    <Phone className="w-4 h-4" />
                    {phone}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-12 pt-8">
          <div className="flex flex-col items-center gap-3 text-center">
            <div className="text-slate-500 text-sm">
              <p className="font-semibold text-slate-700 mb-0.5">UniqueCreative s.r.o.</p>
              <p className="text-slate-400 text-xs mb-0.5">Součást skupiny vzdělávací agentury GAVITO technic s.r.o.</p>
              <p>IČO: 19876815 · Rybná 716/24, Staré Město, 110 00 Praha</p>
            </div>
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} AI pro pedagogy. Všechna práva vyhrazena.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
